import { render } from "./asideBlock.vue?vue&type=template&id=f473de20"
import script from "./asideBlock.vue?vue&type=script&lang=js"
export * from "./asideBlock.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__